import React from "react";
import PropTypes from 'prop-types';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import './ModalConfirm.css';

export default class ModalConfirm extends React.Component {

    static propTypes = {
        onOkClick: PropTypes.func,
        onCancelClick: PropTypes.func,
        header: PropTypes.string,
        message: PropTypes.string,
        show: PropTypes.bool,
        ok: PropTypes.string,
        cancel: PropTypes.string,
        checkboxLabel: PropTypes.string,
        checkboxChecked: PropTypes.bool,
        onCheckboxChange: PropTypes.func,
        /** Optional class on Modal root (e.g. wider confirm). */
        className: PropTypes.string,
        size: PropTypes.string,
    };


    static defaultProps = {
        ok: "OK",
        cancel: "Cancel",
        className: '',
        size: null,
    };

    handleOk = () => {
        if (this.props.onOkClick) {
            this.props.onOkClick();
        }
        // Most callers only hide the dialog in onCancelClick — keep that contract.
        if (this.props.onCancelClick) {
            this.props.onCancelClick();
        }
    };

    render() {
        const className = ['modal-confirm', this.props.className].filter(Boolean).join(' ');
        return (
            <Modal isOpen={this.props.show} className={className} size={this.props.size || undefined}>
                <ModalHeader toggle={this.props.onCancelClick}>{this.props.header}</ModalHeader>
                <ModalBody>
                    <div className="modal-confirm__message" style={{whiteSpace: 'pre-line'}}>
                        {this.props.message}
                    </div>
                    {this.props.checkboxLabel &&
                        <label className="modal-confirm__checkbox">
                            <input
                                type="checkbox"
                                checked={!!this.props.checkboxChecked}
                                onChange={(e) => {
                                    if (this.props.onCheckboxChange) {
                                        this.props.onCheckboxChange(e.target.checked);
                                    }
                                }}
                            />
                            <span>{this.props.checkboxLabel}</span>
                        </label>}
                </ModalBody>
                <ModalFooter className="modal-confirm__footer">
                    {this.props.onCancelClick &&
                        <Button
                            type="button"
                            className="modal-confirm__btn modal-confirm__btn--cancel"
                            onClick={this.props.onCancelClick}
                        >
                            {this.props.cancel}
                        </Button>
                    }
                    <Button
                        type="button"
                        color="primary"
                        className="modal-confirm__btn modal-confirm__btn--ok"
                        onClick={this.handleOk}
                    >
                        {this.props.ok}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
